import { createRouter, createWebHashHistory } from "vue-router";
const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/home"),
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  // if (!window.sessionStorage.getItem(process.env.VUE_APP_TOKEN)) {
  //   if (to.path == "/") {
  //     next();
  //   } else {
  //     router.replace({ path: "/", query: { ...to.query } });
  //   }
  // } else {
  //   next();
  // }
  next()
});
export default router;
